import React from 'react';
import BreakdownRingChart from '../../../../../../../shared/designSystem/components/BreakdownRingChart';

// TransactionCreativeRingChart — thin adapter for the shared BreakdownRingChart.
//
// V2 creatives surface two dimensions: Impressions and Transactions. The
// parent aliases `transactions` → `totalTransactions` on each row; we pass
// either key through as the dimension, and BreakdownRingChart reads the
// matching field via generic `item[dimension]` lookup.
const TransactionCreativeRingChart = ({
  data,
  height,
  selectedCreativeDimension = 'impressions',
}) => (
  <BreakdownRingChart
    data={data}
    dimension={selectedCreativeDimension}
    height={height}
  />
);

export default TransactionCreativeRingChart;
